import React, { useState, useEffect } from 'react';

const CookieBanner = () => {
  const [isCookieBannerVisible, setCookieBannerVisible] = useState(false);

  // Check if user already made a decision about cookies
  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setCookieBannerVisible(true);
    }
  }, []);

  const handleAcceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setCookieBannerVisible(false);
    // Here you can trigger the loading of non-essential cookies, like analytics
  };

  const handleRejectCookies = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setCookieBannerVisible(false);
    // Ensure non-essential cookies aren't loaded
  };

  if (!isCookieBannerVisible) {
    return null;
  }

  return (
    <div
      className="govuk-cookie-banner"
      data-nosnippet
      role="region"
      aria-label="Cookies on MyWishes Care"
    >
      <div className="govuk-cookie-banner__message govuk-width-container">
        <div className="govuk-grid-row">
          <div className="govuk-grid-column-two-thirds">
            <h2 className="govuk-cookie-banner__heading govuk-heading-m">
              Cookies on MyWishes Care
            </h2>
            <div className="govuk-cookie-banner__content">
              <p className="govuk-body">
                We use some essential cookies to make this service work.
              </p>
              <p className="govuk-body">
                We’d also like to use analytics cookies so we can understand how
                you use the service and make improvements. To learn more about
                our Cookie policies{' '}
                <a
                  className="govuk-link"
                  href="https://www.mywishes.co.uk/cookies"
                >
                  click here.
                </a>
              </p>
            </div>
          </div>
        </div>
        <div className="govuk-button-group">
          <button
            type="button"
            className="govuk-button"
            data-module="govuk-button"
            onClick={handleAcceptCookies}
          >
            Accept analytics cookies
          </button>
          <button
            type="button"
            className="govuk-button"
            data-module="govuk-button"
            onClick={handleRejectCookies}
          >
            Reject analytics cookies
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
